module.exports = __webpack_public_path__ + "3514c40b32acc95a879d2275a8e6c34b.svg";